// admin sidebar data
export const sidebarData = () => {
    return [
        {
            label: 'Dashboard',
            icon: 'mdi:view-dashboard-outline',
            href: `/`,
            key: 'dashboard',
        },
        {
            label: 'User Management',
            icon: 'mdi:account-cog-outline',
            href: `/user-management`,
            parentLink: `/user-management`,
            key: 'user_management',
        },
        {
            label: 'General Transaction',
            icon: 'mdi:swap-horizontal',
            href: `/general-transaction`,
            parentLink: `/general-transaction`,
            key: 'general_transactions',
        },
        {
            label: 'General Game History',
            icon: 'mdi:history',
            href: `/game-history`,
            parentLink: `/game-history`,
            key: 'game_history',
        },
        {
            label: 'Shop Cashier Transactions',
            icon: 'mdi:store-outline',
            href: `/shop-cashier-transactions`,
            parentLink: `/shop-cashier-transactions`,
            key: 'shop_cashier_transactions',
        },
        {
            label: 'Provider Management',
            icon: 'mdi:account-group-outline',
            href: `/provider-management`,
            parentLink: `/provider-management`,
            key: 'provider_management',
        },
        {
            label: 'Game Management',
            icon: 'mdi:gamepad-variant-outline',
            href: `/game-management`,
            parentLink: `/game-management`,
            key: 'game_management',
        },
        {
            label: 'Providers Skin Limits',
            icon: 'mdi:border-all',
            href: `/providers-skin-limits`,
            parentLink: `/providers-skin-limits`,
            key: 'provider_skin_limits',
        },
        {
            label: 'General Bet Limits',
            icon: 'mdi:trophy-outline',
            href: `/bet-limits-system`,
            key: 'general_bet_limits',
        },
        // {
        //     label: 'Bet Limits Parameters',
        //     icon: 'mdi:tune',
        //     href: `/bet-limits-parameters`,
        //     key: 'bet_limits_parameters',
        // },
        {
            label: 'Win Limits Parameters',
            icon: 'mdi:trophy-variant-outline',
            href: `/win-limits-parameters`,
            parentLink: `/win-limits-parameters`,
            key: 'win_limits_parameters',
        },
        {
            label: 'General Activity Logs',
            icon: 'mdi:clipboard-text-clock-outline',
            href: `/activity-logs`,
            parentLink: `/activity-logs`,
            key: 'general_activity_logs',
        },
        {
            label: 'Game settings',
            icon: 'ph:game-controller-bold',
            href: `/game-settings`,
            parentLink: `/game-settings`,
            key: 'game_settings',
        },
        {
            label: 'Panic Button Setting',
            icon: 'mdi:warning-circle-outline',
            href: `/panic-button-setting`,
            parentLink: `/panic-button-setting`,
            key: 'panic_button_sSetting',
        },
        {
            label: 'Support Requests',
            icon: 'mdi:paper-edit-outline',
            href: `/support-requests`,
            parentLink: `/support-requests`,
            key: 'support_requests',
        },
        // {
        //     label: 'VPN Configuration',
        //     icon: 'mdi:crown-outline',
        //     href: `/vpn-configuration`,
        //     parentLink: `/vpn-configuration`,
        //     key: 'vpn_configuration',
        // },
    ];
};
